import { css, StyleSheet } from "aphrodite";

const ContactFormSuccess = ({
  firstName,
  messageOtherAgents,
  isPrime,
  isNonPrime,
}) => {
  return (
    <div className={css(styles.successContainer)}>
      <div className={css(styles.successHeader)}>
        <svg
          width="80"
          height="80"
          viewBox="0 0 90 90"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M77.9989 19.5717C76.9692 18.5402 75.2983 18.5384 74.2686 19.5674L42.6191 51.1333L31.2001 38.7311C30.2134 37.6601 28.5452 37.5906 27.4723 38.5772C26.4003 39.5639 26.3317 41.2329 27.3184 42.3049L40.5973 56.7262C41.0836 57.2547 41.7642 57.5617 42.4819 57.5766C42.5011 57.5774 42.5197 57.5774 42.5382 57.5774C43.2356 57.5774 43.9065 57.3004 44.4007 56.8079L77.9937 23.3029C79.0261 22.2741 79.0279 20.6033 77.9989 19.5717Z"
            fill="#608A78"
          />
          <path
            d="M77.3617 42.3617C75.9046 42.3617 74.7236 43.5427 74.7236 45C74.7236 61.3903 61.3903 74.7236 45 74.7236C28.6107 74.7236 15.2764 61.3903 15.2764 45C15.2764 28.6107 28.6107 15.2764 45 15.2764C46.4571 15.2764 47.6383 14.0954 47.6383 12.6383C47.6383 11.181 46.4571 10 45 10C25.7008 10 10 25.7008 10 45C10 64.2984 25.7008 80 45 80C64.2984 80 80 64.2984 80 45C80 43.5429 78.819 42.3617 77.3617 42.3617Z"
            fill="#608A78"
          />
        </svg>
        <div className={css(styles.messageSent)}>
          Your message has been sent!
        </div>
      </div>
      <div>
        {messageOtherAgents ? (
          <>
            {isPrime || isNonPrime
              ? `${firstName} and the other agents`
              : "The agents"}{" "}
            will reach out to you as soon as they review your message.
          </>
        ) : (
          <>
            {isPrime || isNonPrime ? firstName : "The agents"} will reach out to
            you as soon as they review your message.
          </>
        )}
      </div>
    </div>
  );
};

const styles = StyleSheet.create({
  successHeader: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    width: "100%",
    rowGap: 16,
  },
  successContainer: {
    width: "100%",
    textAlign: "center",
    display: "flex",
    flexDirection: "column",
    rowGap: 16,
  },
  messageSent: {
    fontWeight: 600,
    fontSize: 20,
  },
});
export default ContactFormSuccess;
